import { Box, Image } from "@chakra-ui/react";
import React, { useEffect } from "react";
import { COMMON_WEB_PATH } from "../../../../constant";
import { Link, useLocation } from "react-router-dom";
import i18next from "i18next";

const HotTypeMenu = () => {
  const location = useLocation();

  const hash = location.hash.replace("#", "");

  useEffect(() => {
    if (location.hash) {
      const el = document.querySelector(location.hash);
      el?.scrollIntoView({ behavior: "smooth" });
    }
  }, [location.hash]);
  return (
    <Box
      position="fixed"
      right={"0"}
      w="147px"
      h="300px"
      bottom="10%"
      bgImage={`url(${COMMON_WEB_PATH}/now888/roulette/roulette_base_bg.png)`}
      _after={{
        content: '""',
        position: "absolute",
        top: "0",
        left: "0",
        width: "100%",
        height: "100%",
        bgImage: `url(${COMMON_WEB_PATH}/now888/roulette/roulette_${hash}_trigger_bg_.png)`,
        bgSize: "cover",
        bgPos: "center",
        bgRepeat: "no-repeat",
      }}
      bgSize="cover"
      bgPos="center"
      bgRepeat={"no-repeat"}
    >
      <Box w="100%" h="100%" position="relative" zIndex={1}>
        <Box
          as={Link}
          w="70px"
          right="10px"
          top="50px"
          h="30px"
          position="absolute"
          to={{
            hash: "#HOT",
          }}
        >
          <Image
            src={`${COMMON_WEB_PATH}/now888/roulette/HOT_word${
              i18next.language === "tw" ? "" : `_${i18next.language}`
            }.png`}
          />
        </Box>
        <Box
          as={Link}
          w="70px"
          left="22px"
          top="114px"
          h="63px"
          position="absolute"
          to={{
            hash: "#EXCU",
          }}
          display="flex"
          alignItems={"center"}
        >
          <Image
            src={`${COMMON_WEB_PATH}/now888/roulette/EXCU_word${
              i18next.language === "tw" ? "" : `_${i18next.language}`
            }.png`}
          />
        </Box>
        <Box
          as={Link}
          w="70px"
          right="10px"
          bottom="50px"
          h="55px"
          position="absolute"
          to={{
            hash: "#NEW",
          }}
          display="flex"
          alignItems={"center"}
        >
          <Image
            src={`${COMMON_WEB_PATH}/now888/roulette/NEW_word${
              i18next.language === "tw" ? "" : `_${i18next.language}`
            }.png`}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default HotTypeMenu;
